import UploadIcon from 'assets/icons/uploadButton.svg';
import { Button } from 'primereact/button';
import classes from './uploadComponent.module.scss';
import useBulkTmsModalUpload from './useUploadComponent';

const UploadComponent = ({
  toggleVisibility,
  handleDownloadTemplate,
  handleUploadFile,
  isFileUploading
}: {
  toggleVisibility: () => void;
  handleDownloadTemplate: () => void;
  handleUploadFile: (file: File) => void;
  isFileUploading: boolean;
}) => {
  const { file, handleFileChange, handleRemoveFile } = useBulkTmsModalUpload();
  return (
    <div className={classes.BulkTmsModalUploadContainer}>
      <div className={classes.uploadDragSelectContainer}>
        {!file ? (
          <>
            <input
              type="file"
              className={classes.excelFileUploadInputTag}
              accept=".csv, .xlsx"
              onChange={e => handleFileChange(e)}
            />
            <img className={classes.uploadIcon} src={UploadIcon} alt="Upload Excel/CSV" />
            <div className={classes.uploadLabel}>Drag and Drop files here or Choose files</div>
          </>
        ) : (
          <>
            <div className={classes.uploadedFileInfomrationContainer}>
              <div>{file.name}</div>
              <Button className={classes.fileRemoveButton} onClick={handleRemoveFile}>
                Remove
              </Button>
            </div>
          </>
        )}
      </div>
      <div className={classes.buttonsContainer}>
        <Button className={classes.templateDownloadButton} onClick={handleDownloadTemplate}>
          Download Excel Template
        </Button>

        <div className={classes.rightSideButtonsWrapper}>
          <Button className={classes.cancelButton} onClick={toggleVisibility}>
            Cancel
          </Button>
          <Button
            disabled={!file}
            loading={isFileUploading}
            className={classes.uploadButton}
            onClick={() => {
              if (file) {
                handleUploadFile(file);
              }
            }}
          >
            Upload
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UploadComponent;
